/**
 * Add attribute
 * @param {Array<HTMLElement>} targets
 * @param {String} name
 * @param {String} values
 */
const attributeAdd = (targets, name, values = "") => {
  for (const target of targets) {
    /** Initialize the current values from the attribute, or an empty array if not present */
    const current = (target.getAttribute(name) || "")
      .split(" ")
      .filter(Boolean);

    /** If value is already presented in attribute return current, otherwise add new value */
    const updatedValues = current.includes(values)
      ? current
      : [...current, values];

    /** Values to set are defined */
    if (values) {
      /** Set the updated value back to the attribute */
      target.setAttribute(name, updatedValues.join(" ").trim());
    } else {
      /** No values defined. Set whole attribute */
      target.setAttribute(name, values);
    }
  }
};

export default attributeAdd;
